export default __webpack_public_path__ + "static/media/copy.939d37af.svg";